import { xAxisExtensionInstall } from './xAxis';
import { yAxisExtensionInstall } from './yAxis';
import { actionExtensionInstall } from './action';

export default [xAxisExtensionInstall, yAxisExtensionInstall, actionExtensionInstall];
